import gql from 'graphql-tag';

export const GET_POST = gql`
  query getPost($slug: String) {
    post(sid: $slug) {
      id
      title
      certified
      description
      media
      photos
      price
      sid
      mobile
      createdAt
      updatedAt
      category
      subInfos
      userId
      town
      deleted
      userImage
      userName
      additionalType
      alternateName
      stats
      postAuthor {
        prenom
        name
        imageProfil
        certified
      }
      related(limit: 4) {
        id
        additionalType
        title
        media
        photos
        price
        category
        sid
        town
        createdAt
        updatedAt
      }
    }
  }
`;
export const GET_POST_CATEGORY = gql`
  query getPostCategory($id: String) {
    post(id: $id) {
      category
    }
  }
`;

export const GET_POST_FOR_EDIT = gql`
  query getPost($id: String!) {
    post(sid: $id) {
      id
      title
      description
      sid
      category
      media
      photos
      price
      mobile
      media
      category
      userId
      town
      status
      subInfos
    }
  }
`;
